module.exports = __webpack_public_path__ + "img/text.54469889.png";